export default __webpack_public_path__ + "static/other-9e45a290df820d28bd27271bc1c509a7.png";